<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" v-model="debug" :label="$lang.debug" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="flat" :label="$lang.flat" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" /><!--
          --><checkbox label-size="xs" v-model="rounded" :label="$lang.rounded" :icon-color="$root.$colors.primary" :icon-color-lightness="$root.$colors.bgColorLightness" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24" v-if="tools">
        <card :overflow-off="false">
          <card-text>
            <ribbon
              @tab-change="onTabChange"
              @command="onCommand"
              :debug="debug"
              :icon="icon"
              :icon-provider="iconProvider"
              :elevation="flat ? 'none' : 'md'"
              :tools="tools"
              :rounded="rounded"
              :commands="commands"
              :default-tab="defaultTab"
              :tab-panels-bg-color="tabPanelsBgColor"
              :tab-panels-bg-color-lightness="tabPanelsBgColorLightness"
              :tools-color="toolsColor"
              :toggle-tool-disabled="toggleToolDisabled"
              :toggle-tool-item-disabled="toggleToolItemDisabled"
              :tools-color-lightness="toolsColorLightness"
              :tools-bg-color="$root.colors.primary"
              :tools-bg-color-lightness="$root.colors.bgColorLightness" />
          </card-text>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">@command: {{ command }}</code-chunk>
          </card-actions>
          <divider />
          <card-actions align="center">
            <code-chunk :pre="false">@tab-change: {{ tab }}</code-chunk>
          </card-actions>
        </card>
      </flex-col>
      <flex-col :span="24" v-if="tools">
        <h-three :title="$lang.ribbonApi" />
        <paragraph v-html="$lang.ribbonApiInfo" />
        <collapsible v-if="rerendered" :multiple="false" bg-color="transparent" :bg-color-lightness="null" :color="$dark ? 'white' : 'black'" :color-lightness="null" bg-color-expanded="gray" :bg-color-lightness-expanded="$dark ? 900 : 200" :color-expanded="$dark ? 'white' : 'black'" :color-lightness-expanded="null">
          <collapsible-item :label="$lang.theProp('commands')">
            <md-section md="ribbon-command.md" />
            <ul :class="['bullet-list', 'text-xs']">
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['bold', 'underline'], 0, 'btn-group', 2, 'font-style', 4, false)" v-html="$lang.toggleBoldAndUnderline" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['center'], 0, 'btn-group', 3, 'text-align', 0, true)" v-html="$lang.setAlignCenter" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['#2196f3'], 0, 'color-picker', 2, 'background-color', 2)" v-html="$lang.setBgColor" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['#4caf50'], 0, 'color-picker', 2, 'font-color', 6)" v-html="$lang.setFontColor" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['comic-sans-ms'], 0, 'dropdown', 2, 'font-family', 0)" v-html="$lang.setComicSansMS" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['22px'], 0, 'dropdown', 2, 'font-size', 1)" v-html="$lang.setFontSize" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool([true], 0, 'checkbox', 5, 'some-unchecked-checkbox', 0)" v-html="$lang.selectCheckbox" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool(['ts'], 0, 'radio-group', 4, 'js-frameworks', 1)" v-html="$lang.selectTS" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleTool([10], 0, 'numeric-input', 6, 'left-indent', 0)" v-html="$lang.setNumericInput" />
              </li>
            </ul>
          </collapsible-item>
          <collapsible-item :label="$lang.theProp('toggle-tool-disabled')">
            <md-section md="ribbon-toggle-tool-disabled.md" />
            <ul :class="['bullet-list', 'text-xs']">
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 2, 0)" v-html="$lang.toggleDisabled('font-family', 'Font')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 2, 8)" v-html="$lang.toggleDisabled('change-case', 'Font')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 2, 2)" v-html="$lang.toggleDisabled('highlight-color', 'Font')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 4, 1)" v-html="$lang.toggleDisabled('radio-group', 'Editing')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 5, 0)" v-html="$lang.toggleDisabled('checkbox', 'Checkboxes')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledTool(0, 6, 0)" v-html="$lang.toggleDisabled('numeric-input', 'Numeric Inputs')" />
              </li>
            </ul>
          </collapsible-item>
          <collapsible-item :label="$lang.theProp('toggle-tool-item-disabled')">
            <md-section md="ribbon-toggle-tool-item-disabled.md" />
            <ul :class="['bullet-list', 'text-xs']">
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledToolItem('quick-launch', null, null, null, 1)" v-html="$lang.toggleToolItemDisabled('Cut', 'Quick Launch')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledToolItem('btn-group', 0, 1, 0, 1)" v-html="$lang.toggleToolItemDisabled('Copy', 'Clipboard')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledToolItem('menu-list', 0, 2, 8, 4)" v-html="$lang.toggleToolItemDisabled('Toggle Case', 'Change Case')" />
              </li>
              <li :class="['p-1']">
                <a href="#" :class="['text-xs', 'hover:underline']" @click.prevent="toggleDisabledToolItem('dropdown', 0, 2, 0, 2)" v-html="$lang.toggleToolItemDisabled('Consolas', 'Font Family')" />
              </li>
            </ul>
          </collapsible-item>
        </collapsible>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageRibbon',
  mixins: [
    methods
  ],
  data () {
    return {
      rerendered: true,
      command: `<${this.$lang.useRibbonTool}>`,
      tab: `<${this.$lang.clickRibbonTab}>`,
      commands: [],
      toggleToolDisabled: null,
      toggleToolItemDisabled: null,
      tools: null,
      defaultTab: 0,
      debug: true,
      rounded: true,
      flat: false,
      iconProvider: 'mdi',
      icon: 'file-word-box',
      toolsColor: 'white',
      toolsColorLightness: null
    }
  },
  computed: {
    tabPanelsBgColor () {
      return this.$dark ? 'gray' : 'white'
    },
    tabPanelsBgColorLightness () {
      return this.$dark ? 900 : null
    }
  },
  mounted () {
    this.getExternalData('ribbon.json', 'tools')
  },
  watch: {
    $dark () {
      this.repaint()
    }
  },
  methods: {
    repaint () {
      this.rerendered = false
      this.$nextTick(() => {
        this.rerendered = true
      })
    },
    toggleDisabledTool (tab, ribbon, toolIndex) {
      this.toggleToolDisabled = {tab, ribbon, toolIndex}
    },
    toggleDisabledToolItem (type, tab, ribbon, toolIndex, itemIndex) {
      this.toggleToolItemDisabled = {type, tab, ribbon, toolIndex, itemIndex}
    },
    toggleTool (data, tab, type, ribbon, command, toolIndex, exclusive) {
      const commands = []
      data.forEach(item => {
        commands.push({
          tab,
          type,
          ribbon,
          command,
          data: item,
          toolIndex,
          exclusive // for btn-group
        })
      })
      this.commands = commands
    },
    onCommand ($event) {
      this.log('command', 'ribbon', $event)
      this.command = $event
    },
    onTabChange ($event) {
      this.log('tab-change', 'ribbon', $event)
      this.tab = $event
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/ribbon.vue